import {
  Component,
  ViewChild,
  Output,
  EventEmitter,
  Input,
  ChangeDetectorRef,
  OnInit,
  Renderer2,
  SimpleChanges,
  OnChanges,
  SecurityContext,
} from '@angular/core'
import { MatCalendar } from '@angular/material/datepicker'
import { AuthService, TranslationService } from '@spartacus/core'
import { Observable } from 'rxjs/internal/Observable'
import { datePickerService } from './date-picker.service'
import moment from 'moment'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { DomSanitizer } from '@angular/platform-browser'

@Component({
  standalone: false,

  selector: 'vs-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit, OnChanges {
  @Output()
  selectedDate: EventEmitter<any> = new EventEmitter()

  @ViewChild('calendar')
  calendar: MatCalendar<Date>

  @ViewChild('dateInput')
  dateInput

  @ViewChild('datePickerMenu')
  datePickerMenu

  @Input()
  min?: Date

  @Input()
  max?: Date

  @Input()
  defaultDate?: string

  @Input()
  showError?: boolean

  @Input()
  disabled?: boolean

  @Input()
  filterWeekend?: boolean

  @Input()
  activateSelectedDay: boolean

  @Input()
  selectedDay: any

  @Input()
  selectedEntity: any

  @Input()
  dateInputLabel?: string

  showCalendar = false
  calendarDate: Date
  selectDate
  labelText
  holidayList: any[] = []
  flag = true
  data: any
  user$: Observable<any>
  uid: any
  user: any
  year = new Date().getFullYear()
  userType: any
  private scrollListener: (()=> void) | null = null;
  id
  dayOfWeek = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ]
  constructor(
    private cRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private translate: TranslationService,
    private dateService: datePickerService,
    private userAccountFacade: UserAccountFacade,
    private auth: AuthService,
    private domSanitizer: DomSanitizer
  ) {
    this.domSanitizer.sanitize(
      SecurityContext.NONE,
      this.renderer.listen(document, 'click', this.bodyClick.bind(this))
    )
  }

  ngOnInit(): void {
    this.userType = sessionStorage.getItem('userType-current')
    if (!this.defaultDate) {
      this.translate
        .translate('sharedComponents.selectDate')
        .subscribe((res: string) => {
          this.selectDate = res
          this.labelText = this.selectDate
          this.cRef.detectChanges()
        })
    } else {
      this.calendarDate = new Date(this.defaultDate)
      this.labelText = this.getFormattedDate(this.calendarDate)
      this.cRef.detectChanges()
    }
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.user$.subscribe((res) => {
      this.uid = res?.recentSalesArea?.plant
      this.id = res?.recentSalesArea?.plant
      this.user = res?.uid
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['defaultDate']?.currentValue) {
      this.defaultDate = changes['defaultDate'].currentValue
      this.calendarDate = new Date(changes['defaultDate'].currentValue)
      this.labelText = this.getFormattedDate(this.calendarDate)
    }
  }

  resetDate(defDate?) {
    if (!defDate) {
      this.defaultDate = 'changes.defaultDate.currentValue'
      this.calendarDate = new Date()
      this.translate
        .translate('sharedComponents.selectDate')
        .subscribe((res: string) => {
          this.selectDate = res
          this.labelText = this.selectDate
        })
    }
  }

  getFormattedDate(d: Date) {
    return (
      d.getDate() +
      ' ' +
      d.toLocaleString('en-US', { month: 'short' }) +
      ' ' +
      d.getFullYear()
    )
  }

  onDateSelect(event) {
    this.calendarDate = new Date(event)
    this.showCalendar = false
    this.labelText = this.getFormattedDate(this.calendarDate)
    this.emitDateRange()
  }
  yearSelectedCall(event) {
    let currentYear = new Date(event).getFullYear()
    if (this.userType == 'current' && this.showCalendar) {
      this.datesCall(currentYear)
    }
  }
  bodyClick(event) {
    if (
      (event.target as HTMLInputElement)?.closest(
        '.mat-calendar-next-button'
      ) &&
      this.calendar?.activeDate &&
      this.calendar?.currentView != 'year'
    ) {
      let currentYear = new Date(this.calendar.activeDate).getFullYear()
      let currentMonth = new Date(this.calendar.activeDate).getMonth()
      if (
        this.userType == 'current' &&
        this.showCalendar &&
        currentMonth == 0
      ) {
        this.datesCall(currentYear)
      }
    }
    if (
      (event.target as HTMLInputElement)?.closest(
        '.mat-calendar-previous-button'
      ) &&
      this.calendar?.activeDate &&
      this.calendar?.currentView != 'year'
    ) {
      let currentYear = new Date(this.calendar.activeDate).getFullYear()
      let currentMonth = new Date(this.calendar.activeDate).getMonth()
      if (
        this.userType == 'current' &&
        this.showCalendar &&
        currentMonth == 11
      ) {
        this.datesCall(currentYear)
      }
    }
    if (
      (event.target as HTMLInputElement)?.closest(
        '.mat-calendar-next-button, .mat-calendar-previous-button'
      ) &&
      this.calendar?.activeDate &&
      this.calendar?.currentView == 'year'
    ) {
      let currentYear = new Date(this.calendar.activeDate).getFullYear()
      if (this.userType == 'current' && this.showCalendar) {
        this.datesCall(currentYear)
      }
    }
    if (
      this.dateInput &&
      !this.dateInput.nativeElement.contains(event.target) &&
      this.datePickerMenu &&
      !this.datePickerMenu.nativeElement.contains(event.target) &&
      !(event.target as HTMLInputElement)?.closest('.mat-calendar-table')
    ) {
      this.showCalendar = false
      this.cRef.detectChanges()
    }
  }

  onInputClick(event) {
    if (this.selectedEntity != undefined) this.uid = this.selectedEntity
    else this.uid = this.id
    if (this.disabled) {
      return
    }
    this.showCalendar = !this.showCalendar
 

    if (this.userType == 'current' && this.showCalendar) {
      let currYear
      if (this.calendarDate)
        currYear = new Date(this.calendarDate).getFullYear()
      else currYear = new Date().getFullYear()
      this.datesCall(currYear)
    }

    setTimeout(() => {
      this.dateInput.nativeElement.scrollIntoView({ behavior: 'instant', block: 'nearest' })
      this.onCalendarOpen();
    }, 0)
  }

  datesCall(currYear) {
    this.dateService
      .getHolidayDates(this.user, this.uid, currYear)
      .subscribe((res) => {
        this.data = res
        this.data.holidayCalender.forEach((element) => {
          const fromDate = moment(
            new Date(element.holidayFromDate).toISOString().slice(0, 19)
          ).startOf('day')
          const toDate = moment(
            new Date(element.holidayToDate).toISOString().slice(0, 19)
          ).endOf('day')
          const offDayslength = moment.duration(toDate.diff(fromDate)).asDays()
          for (let i = 0; i <= offDayslength; i++) {
            this.holidayList.push(
              moment(fromDate).add(i, 'day').startOf('day').toString()
            )
          }
        })
        this.calendar.updateTodaysDate()
      })
  }
  emitDateRange() {
    this.selectedDate.emit(this.calendarDate)
  }

  dateFilter = (date: Date) => {
    if (
      this.holidayList.find(
        (x) =>
          moment(x).format('DD-MM-YYYY') == moment(date).format('DD-MM-YYYY')
      )
    ) {
      return false
    }

    if (this.activateSelectedDay) {
      if (this.selectedDay?.length > 0) {
        let finalIndexs = []
        this.selectedDay.forEach((day) => {
          this.dayOfWeek.forEach((day2, index) => {
            if (day.toLowerCase() == day2) {
              finalIndexs.push(index)
            }
          })
        })
        for (let i = 0; i < finalIndexs.length; i++) {
          if (date.getDay() == finalIndexs[i]) return true
        }
      }
    }

    if (this.activateSelectedDay) {
      if (date.getDay() == this.selectedDay) return true
      else return false
    }
    if (this.filterWeekend) return date.getDay() != 0 && date.getDay() != 6
    else return true
  }

  dateHolidayWeekendFilter = (date: Date) => {
    if (
      this.holidayList.find(
        (x) =>
          moment(x).format('DD-MM-YYYY') == moment(date).format('DD-MM-YYYY')
      )
    ) {
      return false;
    }

    if (this.filterWeekend) return (date.getDay() != 0 && date.getDay() != 6);
    else return true;
  }

  onCalendarOpen() {
    const updatePosition = () =>{
      const labelRect = this.dateInput.nativeElement.getBoundingClientRect();
      const calendar = document.querySelector('.date-picker') as HTMLElement;
      const calendarHeight = calendar?.offsetHeight || 300;
      const spaceBelow = window.innerHeight - labelRect.bottom;

      if (spaceBelow < calendarHeight) {
        document.documentElement.style.setProperty('--cal-top', 'auto');
        document.documentElement.style.setProperty('--cal-bottom', `${window.innerHeight - labelRect.top}px`);
      } else {
        document.documentElement.style.setProperty('--cal-top', `${labelRect.bottom + 4}px`);
        document.documentElement.style.setProperty('--cal-bottom', 'auto');
      }

      document.documentElement.style.setProperty('--cal-left', `${labelRect.left}px`);
    };

    setTimeout(() => {
      updatePosition();
    });

    this.scrollListener = () =>{
      updatePosition();
    }

    window.addEventListener('scroll', this.scrollListener, true);
  }

  ngOnDestroy(){
    if(this.scrollListener){
      window.removeEventListener('scroll', this.scrollListener, true);
    }
  }
}
